import { render, staticRenderFns } from "./InputSelect.vue?vue&type=template&id=5491d709&scoped=true"
import script from "./InputSelect.ts?vue&type=script&lang=ts&external"
export * from "./InputSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./InputSelect.scss?vue&type=style&index=0&id=5491d709&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5491d709",
  null
  
)

export default component.exports